import localeAntd from 'ant-design-vue/lib/locale-provider/es_ES'

const messages = {
	topBar: {
		issuesHistory: 'Historial',
		typeToSearch: 'Comienza a escribir...',
		actions: 'Aciones',
		status: 'Estado',
		profileMenu: {
			hello: 'Hola',
			billingPlan: 'Plan de pagos',
			role: 'Rol',
			email: 'Correo Electronico',
			phone: 'Telefono',
			editProfile: 'Editar perfil',
			logout: 'Cerrar sesion',
		},
	},
}

export default {
	locale: 'es-ES',
	localeAntd,
	messages,
}
